import { render, staticRenderFns } from "./ChoosePlanTab.vue?vue&type=template&id=1646e200&scoped=true&"
import script from "./ChoosePlanTab.vue?vue&type=script&lang=ts&"
export * from "./ChoosePlanTab.vue?vue&type=script&lang=ts&"
import style0 from "./ChoosePlanTab.vue?vue&type=style&index=0&id=1646e200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1646e200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VContainer,VRow,VTab,VTabs,VTabsSlider})
